<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="parent">Monitoring Platform &nbsp;/&nbsp; </span>
        <span slot="current">IDUs</span>
        <span slot="title">
          <i class="far fa-newspaper"></i> IDUs {{ records.length }}
          <small> Facts</small>
        </span>
      </AffixHeader>

      <div id="map-border"><div id="map"></div></div>

      <AgGridVue
        style="width: 100%; height: 840px;"
        class="ag-theme-balham"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="records"
      ></AgGridVue>
    </i-col>
  </Row>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Detail from "./idus_row_detail";
import { AgGridVue } from "ag-grid-vue";
import { auth_token } from "@/plugins/auth_token";
import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
import "leaflet-extra-markers";
const DetailCellRenderer = Vue.extend(Detail);

// -----------------------------------------------------------
// Map related variables
// -----------------------------------------------------------
const L = window.L;
let map;
// -----------------------------------------------------------
// Icon marker classes
// -----------------------------------------------------------
let displacementIconMarker = L.ExtraMarkers.icon({
  icon: "fa-child",
  markerColor: "blue",
  shape: "circle",
  prefix: "fa",
});

export default {
  components: { AgGridVue },
  data() {
    return {
      records: [],
      markers: [],
      gridOptions: {
        sideBar: false,
        enableRangeSelection: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        masterDetail: true,
        frameworkComponents: { DetailCellRenderer },
        detailCellRenderer: "DetailCellRenderer",
        onCellMouseOver: this.placeLocationMarker,
        onCellMouseOut: this.removeLocationMarker,
        detailRowHeight: 70,
        onGridReady: params => {
          params.api.sizeColumnsToFit();
        },
        getContextMenuItems: params => [
          {
            name: "Create Fact",
            action: () => {
              this.getFact(params.node.data.fact_id);
            },
            icon: '<i class="fas fa-plus"></i>',
          },
          "separator",
          "copy",
          "copyWithHeaders",
          "paste",
          "separator",
          "toolPanel",
          "export",
        ],
      },
      columnDefs: Object.freeze([
        {
          headerName: "Name",
          width: 50,
          field: "name",
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerName: "Cause",
          width: 15,
          field: "displacement_type",
        },
        {
          headerName: "Figure",
          width: 20,
          field: "figure",
        },
        {
          headerName: "Sources",
          width: 10,
          field: "sources",
        },
        {
          headerName: "URL",
          width: 10,
          field: "url",
        },
        {
          headerName: "Excerpt",
          width: 10,
          field: "excerpt_for_idu",
        },
        {
          headerName: "Created By",
          width: 10,
          field: "created_by",
        },
      ]),
    };
  },
  created() {
    this.loadList();
  },
  mounted() {
    map = L.map("map").setView([0.0, 0.0], 2);
    map.scrollWheelZoom.disable();

    L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      attribution: `&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors`,
    }).addTo(map);
  },
  methods: {
    loadList() {
      axios
        .get("/psql/idus_facts_view")
        .then(response => {
          this.records = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getFact(factID) {
      axios
        .get("/psql/idus_facts_view", {
          params: {
            fact_id: `eq.${factID}`,
          },
          headers: {
            Authorization: auth_token,
            Accept: "application/vnd.pgrst.object+json",
          },
        })
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    },
    placeLocationMarker(event) {
      let centroid = JSON.parse(event.data.centroid);
      let marker = L.marker(centroid, {
        icon: displacementIconMarker,
        title: event.data.name,
        draggable: true,
      });
      marker.addTo(map);
      this.markers.push(marker);
      // this.findBestZoom();
    },
    removeLocationMarker() {
      if (this.markers.length > 0) {
        this.markers.forEach(marker => {
          map.removeLayer(marker);
        });
      }
      this.markers = [];
      // this.findBestZoom();
    },
    findBestZoom() {
      if (this.markers.length > 0) {
        let featureGroup = L.featureGroup(this.markers);
        map.fitBounds(featureGroup.getBounds().pad(0.5), { animate: false });
      } else {
        map.setView([0.0, 0.0], 2);
      }
    },
  },
};
</script>

<style lang="css">
#map-border {
  padding: 3px;
  border: 1px solid #dddee1;
  background-color: white;
  border-radius: 3px;
  margin: 0 0 12px 0;
}

#map {
  height: 480px;
  border-radius: 3px;
}
</style>
